import * as mutationTypes from '@/store/mutation-types'

export default {
  [mutationTypes.setUp] (state, payload) {
    state.information = payload.information
  },
  /**
   * 表示切り替え
   * @param state
   */
  [mutationTypes.switchingListView] (state) {
    state.quiz_list_view = (state.quiz_list_view % 2) + 1
    state.page_number = 1
  },
  /**
   * 回答結果（正解）セット
   * @param state
   * @param {CorrectInformation} correctInformation
   */
  [mutationTypes.setResultCorrectInformation] (state, { correctInformation }) {
    state.result_correct_information = correctInformation
  },
  /**
   * 回答結果（不正解）セット
   * @param state
   * @param {IncorrectInformation} incorrectInformation
   */
  [mutationTypes.setResultIncorrectInformation] (state, { incorrectInformation }) {
    state.result_incorrect_information = incorrectInformation
  },
  /**
   * 回答結果（正解）削除
   * @param state
   */
  [mutationTypes.removeResultCorrectInformation] (state) {
    state.result_correct_information = null
  },
  /**
   * 回答結果（不正解）削除
   * @param state
   */
  [mutationTypes.removeResultIncorrectInformation] (state) {
    state.result_incorrect_information = null
  },
  /**
   * uq_list更新
   * @param state
   * @param uqList
   */
  [mutationTypes.updateUqList] (state, { uqList }) {
    state.information.uq_list = uqList
  },
  /**
   * ログイン
   * @param state
   */
  [mutationTypes.login] (state) {
    state.is_login = true
  },
  /**
   * ログアウト
   * @param state
   */
  [mutationTypes.logout] (state) {
    state.is_login = false
  },
  /**
   * ページ番号セット
   * @param state
   * @param pageNumber
   */
  [mutationTypes.setPageNumber] (state, { pageNumber }) {
    state.page_number = pageNumber
  },
  /**
   * 現在のポイント更新
   * @param state
   * @param point
   */
  [mutationTypes.updatePoint] (state, { point }) {
    state.information.point = point
  },
  /**
   * ローディングON
   * @param state
   * @param payload
   */
  [mutationTypes.onLoadingWait] (state, payload) {
    if (state.loading_waits[payload.loading_wait_type] === undefined) {
      // stateで初期化を行っていないtype
      throw new Error(`${payload.loading_wait_type} is undefined`)
    }
    state.loading_waits[payload.loading_wait_type] = true
  },
  /**
   * ローディングOFF
   * @param state
   * @param payload
   */
  [mutationTypes.offLoadingWait] (state, payload) {
    state.loading_waits[payload.loading_wait_type] = false
  }
}
